export default __webpack_public_path__ + "static/media/me3_UniversalLearner_Image.eca866a1.png";